import { createFileRoute, redirect } from '@tanstack/react-router';
export { DashboardFacturacionPage, empresaCommercialSummary } from '@/components/DashboardFacturacionPage';

export const Route = createFileRoute('/_authenticated/dashboard/empresa')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/facturacion', replace: true });
  },
});
